<template>
  <footer class="nav-footer" role="contentinfo" aria-label="Site footer">
    <div class="footer-row footer-sponsors">
      <p class="sponsors-text">Sponsored by <a href="https://imagobene.com" target="_blank" rel="noopener noreferrer">Imago Bene</a> and <a href="https://simbastickers.com" target="_blank" rel="noopener noreferrer">Simba Stickers</a></p>
    </div>

    <div class="footer-row footer-brand">
      <p class="brand-text">Built for <a href="https://buildwithhtml5.com">Build with HTML5</a> by <a href="https://virtuarama.com" target="_blank" rel="noopener noreferrer">Virtuarama</a></p>
    </div>
  </footer>
</template>

<script setup lang="ts">
// No script logic required for this static footer at the moment.
</script>

<style lang="scss" scoped>
@use '../../styles/variables' as *;

.nav-footer {
  width: 100%;
  background: var(--card-bg);
  border-top: 2px solid var(--border-base);
  box-shadow: $shadow-sm;
  position: static;
  bottom: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-primary);
}

.footer-row {
  width: 100%;
  max-width: $container-max-width;
  padding: 10px $container-padding;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-sponsors {
  border-bottom: 1px solid var(--border-base);
  background: transparent;
}

.sponsors-text,
.brand-text {
  margin: 0;
  text-align: center;
  font-size: $font-size-base;
  color: var(--text-primary);
}

.sponsors-text a,
.brand-text a {
  display:inline-flex;
  padding: 0 5px;
   background: var(--card-bg);
 color: $primary;
  text-decoration: none;
  transition:  color $transition-slow, transform $transition-slow;


}

.sponsors-text a:hover,
.brand-text a:hover {
 	transform: scale(1.25) translate(-5%, -5%);
    color: darken($primary, 6%);
}

/* Make footer text slightly smaller on small screens */
@media (max-width: $breakpoint-sm) {
  .sponsors-text,
  .brand-text {
    font-size: 0.9rem;
  }

  .footer-row {
    padding: 10px $spacing-md;
  }
}


/* Footer uses CSS theme variables so borders/text follow light/dark themes
   The assessment header uses: border-bottom: 2px solid var(--border-base);
   Using var(--border-base) here ensures identical colours in both themes. */

</style>
